import { Theme } from '@mui/material/styles'

export const getSXStyles = (isMobile: boolean) => ({
  centered: {
    alignItems: 'center',
    display: 'inline-flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: (theme: Theme) => theme.spacing(2),
    paddingTop: (theme: Theme) => theme.spacing(0),
    width: '100%',
  },

  title: {
    width: isMobile ? '470px' : '766px',
  },

  main: {
    alignContent: 'center',
    display: 'inline-flex',
    flexDirection: 'row',
    width: isMobile ? '470px' : '766px',
  },
})
